import { ConflictError, ConnectionError, NotFoundError, ServiceUnavailableError } from '../../modules/app/errors';
import { RegisterBadRequestError, RegisterConflictError } from './errors';

const linkShopDetails = venueId => `${api_config.bet_tracker_api}/shopdetails/${venueId}`;
const checkCardEndpoint = cardNumber => `${api_config.bet_tracker_api}/card/${cardNumber}`;
const registerCardEndpoint = `${api_config.bet_tracker_api}/register`;
const resendEndpoint = phone => `${api_config.bet_tracker_api}/sendWelcomeText/${phone}`;

const ADDITIONAL_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

// eslint-disable-next-line import/prefer-default-export
export const getShopDetails = (venueId) => (
  fetch(linkShopDetails(venueId), {
    method: 'GET',
    credentials: 'omit'
  })
    .catch(e => {
      throw new ConnectionError(e.message, null, e);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => ((response.status === 200) ? response.json() : response))
);

export const checkCardNumber = (cardNumber) => (
  fetch(checkCardEndpoint(cardNumber), {
    method: 'HEAD',
    credentials: 'omit'
  })
    .catch(e => {
      throw new ConnectionError(e.message, null, e);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return true;
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 409: {
          throw new ConflictError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);

export const registerCard = (venueId, cardNumber, phoneNumber, consents) => {
  let status;
  let statusText;

  const switchStatus = json => {
    switch (status) {
      case 201: {
        return true;
      }
      case 400: {
        throw new RegisterBadRequestError(statusText, status, json);
      }
      case 409: {
        throw new RegisterConflictError(statusText, status, json);
      }
      case 520: {
        throw new ServiceUnavailableError(statusText, status, json);
      }
      default: {
        throw new ConnectionError(statusText, status, json);
      }
    }
  };

  return fetch(registerCardEndpoint, {
    method: 'PUT',
    headers: ADDITIONAL_HEADERS,
    body: JSON.stringify({ consents, cardNumber, phoneNumber, venueId }),
    credentials: 'omit'
  })
    .catch(e => {
      throw new ConnectionError(e.statusText, e.status);
    })
    .then(response => {
      /* eslint-disable prefer-destructuring */
      status = response.status;
      statusText = response.statusText;
      /* eslint-enable prefer-destructuring */
      return response.json();
    })
    .then(switchStatus, switchStatus);
};

export const resendConfirmationMessage = (phoneNumber) => (
  fetch(resendEndpoint(phoneNumber), {
    method: 'POST',
    headers: ADDITIONAL_HEADERS,
    credentials: 'omit'
  })
    .catch(e => {
      throw new ConnectionError(e.message, null, e);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
